export const GET_CV_PDF_LINK = 'GET_CV_PDF_LINK';
export const GET_PREVIEW_CV_PDF_LINK = 'GET_PREVIEW_CV_PDF_LINK';
